import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
import { Lang } from '../types';
interface ForWhoProps {
  lang: Lang;
}
const content = {
  en: {
    title: 'This Is For You If…',
    wantsTitle: 'You want this',
    dontWantsTitle: "You don't want this",
    items: [{
      want: 'Clean, minimal fine line work',
      dontWant: 'Generic Pinterest designs'
    }, {
      want: 'A custom piece built for your body',
      dontWant: 'Something rushed or improvised'
    }, {
      want: 'Professional studio environment',
      dontWant: 'Random walk-in experience'
    }, {
      want: 'Clear guidance on size & placement',
      dontWant: 'Guessing and hoping for the best'
    }, {
      want: 'A tattoo that ages well',
      dontWant: 'Blurry lines that fade fast'
    }]
  },
  es: {
    title: 'Esto es para ti si…',
    wantsTitle: 'Quieres esto',
    dontWantsTitle: 'No quieres esto',
    items: [{
      want: 'Fine Line limpio y minimalista',
      dontWant: 'Diseños genéricos de Pinterest'
    }, {
      want: 'Una pieza personalizada para tu cuerpo',
      dontWant: 'Algo hecho rápido e improvisado'
    }, {
      want: 'Experiencia profesional en estudio',
      dontWant: 'Entrar sin cita y esperar'
    }, {
      want: 'Guía clara de tamaño y ubicación',
      dontWant: 'Adivinar y esperar lo mejor'
    }, {
      want: 'Un tatuaje que envejece bien',
      dontWant: 'Líneas borrosas que se pierden rápido'
    }]
  }
};
export function ForWhoSection({
  lang
}: ForWhoProps) {
  const t = content[lang];
  return <section className="py-12 md:py-16 bg-studio-bgAlt border-y border-studio-border" data-id="element-169">
      <div className="max-w-5xl mx-auto px-6" data-id="element-170">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center mb-8 md:mb-10" data-id="element-171">
          {t.title}
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8 md:gap-0 border border-studio-border rounded-lg overflow-hidden" data-id="element-172">
          {/* Wants Column */}
          <div className="bg-studio-bg p-6 md:p-8 md:border-r border-studio-border" data-id="element-173">
            <h3 className="text-xl font-playfair font-semibold mb-5 flex items-center gap-3 text-studio-text" data-id="element-174">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-green-500/10 text-green-500" data-id="element-175">
                <Check size={18} data-id="element-176" />
              </span>
              {t.wantsTitle}
            </h3>
            <ul className="space-y-4" data-id="element-177">
              {t.items.map((item, i) => <motion.li key={`want-${i}`} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="flex items-start gap-4 text-studio-muted" data-id="element-178">
                  <Check size={20} className="text-green-500/70 mt-0.5 shrink-0" data-id="element-179" />
                  <span data-id="element-180">{item.want}</span>
                </motion.li>)}
            </ul>
          </div>

          {/* Don't Wants Column */}
          <div className="bg-studio-bgAlt p-6 md:p-8" data-id="element-181">
            <h3 className="text-xl font-playfair font-semibold mb-5 flex items-center gap-3 text-studio-text" data-id="element-182">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-red-500/10 text-red-500" data-id="element-183">
                <X size={18} data-id="element-184" />
              </span>
              {t.dontWantsTitle}
            </h3>
            <ul className="space-y-4" data-id="element-185">
              {t.items.map((item, i) => <motion.li key={`dont-${i}`} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="flex items-start gap-4 text-studio-muted" data-id="element-186">
                  <X size={20} className="text-red-500/70 mt-0.5 shrink-0" data-id="element-187" />
                  <span data-id="element-188">{item.dontWant}</span>
                </motion.li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}